import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Card, majorScale, Pane, Small, Text } from "evergreen-ui";
import { formatCurrency } from "../utils/formatters";

const POsList = ({ onSelect, paneProps, pos }) => {
  const [selectedPO, setSelectedPO] = useState();

  useEffect(() => {
    if (pos) {
      setSelectedPO();
    }
  }, [pos]);

  useEffect(() => {
    onSelect(selectedPO);
  }, [onSelect, selectedPO]);

  const handlePOClick = useCallback(
    (po) => () => {
      setSelectedPO((prev) => (!prev || po !== prev ? po : null));
    },
    []
  );

  const items =
    Array.isArray(pos) &&
    pos.map((po) => (
      <Card
        columnGap={majorScale(2)}
        display="grid"
        grid={`"po_number vendor" "request_name_list amount" / auto auto`}
        rowGap={8}
        background={po === selectedPO ? "blueTint" : null}
        cursor="pointer"
        elevation={po === selectedPO ? 3 : 1}
        key={po["id"]}
        padding={8}
        margin={8}
        onClick={handlePOClick(po)}
      >
        <Pane gridArea="po_number">
          <Text size={500}>
            {`PO#: ${po["netsuite_number"] || po["po_number"]}`}
            {po["po_date"] && (
              <Small fontStyle="italic"> ({po["po_date"]})</Small>
            )}
          </Text>
        </Pane>
        <Pane gridArea="vendor" textAlign="right">
          {po["vendor_name"] && <Text>Vendor: {po["vendor_name"]}</Text>}
        </Pane>
        <Pane gridArea="request_name_list">
          <Text>
            {po["request_name_list"]?.map((name) => (
              <Fragment key={name}>
                {name}
                <br />
              </Fragment>
            ))}
          </Text>
        </Pane>
        <Pane gridArea="amount" justifySelf="end">
          <Text>{formatCurrency(po["amount"])}</Text>
        </Pane>
      </Card>
    ));

  return <Pane {...paneProps}>{items}</Pane>;
};

export default POsList;
